/* eslint-disable react/jsx-no-target-blank */
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useRef } from "react";
import Navigation from "./components/Navigation";
import About from "./components/About";
import Pendidikan from "./components/Pendidikan";
import Pengalaman from "./components/Pengalaman";
import Skill from "./components/Skill";
import Portofolio from "./components/Portofolio";
import Profile from "./components/Profile";

function App() {
  const aboutRef = useRef(null);
  const pendidikanRef = useRef(null);
  const pengalamanRef = useRef(null);
  const skillRef = useRef(null);
  const portofolioRef = useRef(null);

  const scrollToRef = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 min-h-screen lg:h-screen lg:flex lg:items-center lg:justify-center lg:py-10 lg:overflow-hidden">
      <div className="container mx-auto bg-blue-50 lg:rounded-lg shadow-2xl lg:overflow-hidden lg:max-h-[calc(100vh-5rem)] flex flex-col">
        {/*Navigasi*/}
        <BrowserRouter>
          <Navigation
            scrollToAbout={() => scrollToRef(aboutRef)}
            scrollToPendidikan={() => scrollToRef(pendidikanRef)}
            scrollToPengalaman={() => scrollToRef(pengalamanRef)}
            scrollToSkill={() => scrollToRef(skillRef)}
            scrollToPortofolio={() => scrollToRef(portofolioRef)}
          />
          {/* Profile */}
          <section className="flex flex-1 overflow-hidden h-full">
            <Profile />
            {/* End Profile */}

            {/* Main Dekstop */}
            <div className="w-full lg:w-2/3 bg-blue-50 rounded-br-lg hidden lg:block lg:overflow-y-auto lg:h-full scrollbar-hide">
              <Routes>
                <Route path="/" element={<About />} />
              </Routes>
              <Routes>
                <Route path="/about" element={<About />} />
                <Route path="/pendidikan" element={<Pendidikan />} />
                <Route path="/pengalaman" element={<Pengalaman />} />
                <Route path="/skill" element={<Skill />} />
                <Route path="/Portofolio" element={<Portofolio />} />
              </Routes>
            </div>
            {/* End Main Desktop */}
          </section>
          {/* Mobile */}
          <div className="flex bg-blue-50 rounded-b-lg lg:hidden border-t-2 border-blue-200 pb-6">
            <div className="p-4 w-full">
              <div ref={aboutRef} className="scroll-mt-24 sm:scroll-mt-36"><About /></div>
              <hr></hr>
              <div ref={pendidikanRef} className="scroll-mt-20 sm:scroll-mt-32"><Pendidikan /></div>
              <hr></hr>
              <div ref={pengalamanRef} className="scroll-mt-20 sm:scroll-mt-32"><Pengalaman /></div>
              <hr></hr>
              <hr></hr>
              <div ref={skillRef} className="scroll-mt-20 sm:scroll-mt-32"><Skill /></div>
              <hr></hr>
              <div ref={portofolioRef} className="scroll-mt-20 sm:scroll-mt-32"><Portofolio /></div>
            </div>
          </div>
          {/* End Main Mobile */}
        </BrowserRouter>
        {/*End Navigasi */}
      </div>
    </div>
  );
}

export default App;
